import React from 'react';
import { IonIcon, IonSpinner } from '@ionic/react';
import { searchOutline, locationOutline, closeCircle, navigateCircleOutline } from 'ionicons/icons';
import { useLocationSearch } from '../../../application/use-cases/location/useLocationSearch';

// Buscador arriba del mapa: escribís una localidad o pegás coordenadas, y
// al elegir una opción se marca ese punto (después se puede afinar tocando
// el mapa).
const LocationSearch: React.FC<{ onPick: (lat: number, lng: number) => void }> = ({ onPick }) => {
  const { query, setQuery, options, searching, error, clear } = useLocationSearch();
  const showList = query.trim().length >= 2 && (options.length > 0 || (!searching && !error));

  return (
    <div className="location-search">
      <div className="location-search-input">
        <IonIcon icon={searchOutline} />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar localidad o pegar coordenadas"
          aria-label="Buscar ubicación"
          autoComplete="off"
        />
        {searching && <IonSpinner name="crescent" />}
        {!searching && query && (
          <button type="button" onClick={clear} aria-label="Borrar búsqueda">
            <IonIcon icon={closeCircle} />
          </button>
        )}
      </div>
      {error && <p className="location-search-error">{error}</p>}
      {showList && (
        <ul className="location-search-list" role="listbox">
          {options.map((o) => (
            <li key={o.key}>
              <button
                type="button"
                role="option"
                aria-selected={false}
                onClick={() => {
                  onPick(o.lat, o.lng);
                  clear();
                }}
              >
                <IonIcon icon={o.key === 'coords' ? navigateCircleOutline : locationOutline} />
                <span>
                  <strong>{o.title}</strong>
                  {o.detail && <small>{o.detail}</small>}
                </span>
              </button>
            </li>
          ))}
          {options.length === 0 && <li className="location-search-empty">Sin resultados. Probá con la localidad más cercana.</li>}
        </ul>
      )}
    </div>
  );
};

export default LocationSearch;
